import React, {useState} from 'react';
import './Candidates.css';
import { Box, Typography } from '@mui/material';

function Candidates() {

  return (
    <section className='candidates'>
      <Typography sx={{fontSize:'24px'}}>Возможные кандидаты</Typography>
    </section>
  )
}
export default Candidates;